var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFamiliaamigos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_2",
    viewBox: "0 0 173.26 174.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2,.cls-3,.cls-4,.cls-5{fill:#fff;}.cls-6{fill:url(#linear-gradient-17);}.cls-7{fill:#e4b080;}.cls-3{opacity:.43;}.cls-3,.cls-4,.cls-5,.cls-8{isolation:isolate;}.cls-9{fill:url(#linear-gradient-15);}.cls-10{fill:url(#linear-gradient-18);}.cls-11{fill:#615953;}.cls-12{fill:url(#linear-gradient-14);}.cls-13{mask:url(#mask-2);}.cls-14{fill:url(#linear-gradient-20);}.cls-15{fill:url(#linear-gradient-6);}.cls-16{fill:#becef5;}.cls-17{fill:#e77a6e;}.cls-4{opacity:.86;}.cls-18{fill:#c14820;}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:#95b1f2;}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:#e5d8d2;}.cls-23{fill:#f4f2f0;}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:#f2b3b0;}.cls-26{fill:#111179;}.cls-27{fill:#f2bcba;}.cls-28{fill:url(#linear-gradient-21);}.cls-29{fill:#9f958d;}.cls-30{fill:url(#linear-gradient-5);}.cls-31{fill:#1f4195;}.cls-32{fill:#8096eb;}.cls-5{opacity:.88;}.cls-33{fill:#f3d0d5;}.cls-34{fill:url(#linear-gradient-7);}.cls-35{fill:#f1b5b3;}.cls-8{fill:#476aee;opacity:.5;}.cls-36{fill:url(#linear-gradient-9);}.cls-37{fill:url(#linear-gradient-22);}.cls-38{fill:#9a9999;}.cls-39{mask:url(#mask-1);}.cls-40{mask:url(#mask);}.cls-41{fill:url(#linear-gradient-3);}.cls-42{fill:#cdc3bc;}.cls-43{fill:url(#linear-gradient);}.cls-44{fill:#ec8880;}.cls-45{fill:url(#linear-gradient-19);}.cls-46{fill:url(#linear-gradient-4);}.cls-47{fill:url(#linear-gradient-8);}.cls-48{fill:url(#linear-gradient-12);}.cls-49{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 195.53,
    y1: 7134.34,
    x2: 40.78,
    y2: 7326.38,
    gradientTransform: "translate(0 7359.51) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8edfa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 160.33,
    y1: 7385.48,
    x2: 147.42,
    y2: 7354.28,
    gradientTransform: "translate(0 7359.51) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee958f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb7869"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 121.06,
    y: 3.8,
    width: 38.84,
    height: 41.61,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_5_27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m140.48,42.67c10.72,0,19.42-8.7,19.42-19.44s-8.69-19.44-19.42-19.44-19.42,8.7-19.42,19.44,8.69,19.44,19.42,19.44Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 142.62,
    y1: 7352.36,
    x2: 133.59,
    y2: 7317.92,
    gradientTransform: "translate(0 7359.51) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#060559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171889"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 140.52,
    y1: 7352.91,
    x2: 131.49,
    y2: 7318.46,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 152.4,
    y1: 7349.81,
    x2: 143.37,
    y2: 7315.36,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 125.28,
    y1: 7369.35,
    x2: 133.9,
    y2: 7347.85,
    gradientTransform: "translate(0 7359.51) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bcba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee958f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 138.33,
    y1: 7343.54,
    x2: 141.53,
    y2: 7320.57,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 132.55,
    y1: 7356.57,
    x2: 158.19,
    y2: 7312.06,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 137.84,
    y1: 7356.61,
    x2: 148.52,
    y2: 7338.06,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 130.2,
    y1: 7354.42,
    x2: 159.77,
    y2: 7312.44,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 186.74,
    y1: 7374.55,
    x2: 173.83,
    y2: 7343.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 132.01,
    y: 52.15,
    width: 41.17,
    height: 39.76,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1_5_27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m151.43,91.02c10.72,0,19.42-8.7,19.42-19.44s-8.69-19.44-19.42-19.44-19.42,8.7-19.42,19.44,8.69,19.44,19.42,19.44Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 164.13,
    y1: 7287.41,
    x2: 169.41,
    y2: 7269.82,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 134.11,
    y1: 7281.84,
    x2: 139.46,
    y2: 7263.98,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 166.57,
    y1: 7310.84,
    x2: 142.27,
    y2: 7250.65,
    gradientTransform: "translate(0 7359.51) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e58f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f48d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 151.99,
    y1: 7288,
    x2: 152.78,
    y2: 7274.56,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 150.39,
    y1: 7298.73,
    x2: 161.65,
    y2: 7283.72,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 153.7,
    y1: 7301.21,
    x2: 164.96,
    y2: 7286.2,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 146.57,
    y1: 7295.85,
    x2: 157.83,
    y2: 7280.86,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 146.42,
    y1: 7293.55,
    x2: 157.33,
    y2: 7293.55,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 151.95,
    y1: 7289.49,
    x2: 151.95,
    y2: 7309.75,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 141.52,
    y1: 7284.85,
    x2: 147.21,
    y2: 7265.89,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 159.87,
    y1: 7290.05,
    x2: 166.1,
    y2: 7269.28,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 106.22,
    y: 98.25,
    width: 38.84,
    height: 42.49,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask2_5_27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m125.64,137.12c10.72,0,19.42-8.7,19.42-19.43s-8.69-19.44-19.42-19.44-19.42,8.7-19.42,19.44,8.69,19.43,19.42,19.43Z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m152.89,149.47c-2.91,3-6.12,5.7-9.57,8.06-31.21,22.43-68.13,15.88-75.97,14.29-11.59-2.35-33.99-6.91-50.19-25.97C-7.33,117.02-3.52,71.58,15.48,41.55,18.97,36.05,37.32,5.66,74.65.73c22.59-2.95,48.91,3.01,67.98,19,39.99,33.62,37.16,101.42,10.26,129.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m168.14,2.37c1.84,18.34,8.24,125.46-91.13,149.52,0,0-22.34-69.44,88.67-150.62.22-.16.48-.26.75-.29.27-.03.55.01.8.13.25.11.47.29.63.51.16.22.26.48.29.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m158.6,18.26c-1.75,5.61-3.61,11.22-5.51,16.77-1.9,5.55-3.89,11.11-5.93,16.63-2.04,5.52-4.15,11.02-6.31,16.5-2.16,5.47-4.43,10.9-6.72,16.31-4.66,10.81-9.65,21.49-15.21,31.87-2.77,5.23-5.73,10.33-8.86,15.3-3.13,5.03-6.56,9.86-10.26,14.48-.08.09-.19.15-.32.17s-.25-.02-.34-.1c-.1-.08-.16-.19-.17-.32-.01-.12.02-.25.1-.34,3.69-4.56,7.11-9.33,10.23-14.3,3.15-4.95,6.11-10.03,8.89-15.2,5.6-10.34,10.6-20.98,15.31-31.76,2.34-5.4,4.6-10.82,6.8-16.27,2.2-5.45,4.32-10.93,6.38-16.45,2.05-5.5,4.05-11.04,5.98-16.6,1.93-5.61,3.81-11.14,5.6-16.74.02-.05.05-.09.1-.11.05-.02.1-.03.15-.01.03.02.06.05.08.08.02.03.03.07.02.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m169.82,90.37c.02-.18-.01-.36-.11-.52-.09-.16-.24-.28-.41-.34-.17-.07-.36-.07-.53-.02-.17.06-.32.17-.43.32-4.63,6.73-17.31,23.85-30.15,30.85-20.89,11.39-40.34,34.91-35.41,52.26,0,0,56.06,8.49,67.03-82.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m167.09,102.83l-.36.59-.37.56-.74,1.12-1.51,2.24c-1.03,1.49-2.07,2.96-3.13,4.4-2.11,2.9-4.3,5.76-6.53,8.58-2.23,2.82-4.48,5.61-6.9,8.3l-.87,1.02-.9,1.01c-.61.67-1.19,1.35-1.8,2.01l-1.83,2-1.85,1.96c-4.95,5.23-10.22,10.14-15.78,14.71l-.52.44-.53.41-1.06.83-1.12.83c-.36.28-.72.54-1.12.81l-1.12.81c-.36.26-.72.54-1.12.78l-2.24,1.55c-2.98,2.01-6.08,3.84-9.28,5.5-.01,0-.02,0-.03,0-.01,0-.02,0-.03,0-.01,0-.02,0-.03-.02,0,0-.02-.02-.02-.02,0-.01,0-.02,0-.03,0-.01,0-.02,0-.03,0-.01,0-.02.02-.03,0,0,.02-.02.02-.02,3.15-1.7,6.21-3.57,9.16-5.61l2.24-1.56c.37-.25.72-.53,1.12-.8l1.12-.81,1.12-.82,1.05-.84,1.04-.84.53-.42.52-.44,2.06-1.73c.68-.58,1.36-1.18,2.03-1.77l1.01-.89.99-.91,1-.91.99-.92c2.61-2.46,5.13-5.01,7.62-7.6,4.98-5.18,9.67-10.62,14.19-16.19,2.24-2.8,4.44-5.63,6.61-8.51,1.08-1.44,2.14-2.88,3.18-4.34.53-.74,1.04-1.47,1.55-2.24l.76-1.12.37-.56c.12-.19.26-.38.36-.56,0,0,.02-.01.03-.02,0,0,.02,0,.03,0,.01,0,.02,0,.03,0,0,0,.02.01.03.02.01,0,.02.02.03.03,0,.01.01.03.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m5.92,11.65c-.68,27.31-2.88,121.5-1.83,154.89.06,1.7.76,3.32,1.97,4.52,1.2,1.2,2.82,1.9,4.52,1.96,17.48.57,67.75,2.02,96.37.82,2.87-.12,5.58-1.33,7.59-3.38,2.01-2.05,3.16-4.79,3.23-7.66.59-28.67,1.9-109.29-1.21-146.22-.18-2.16-1.1-4.18-2.62-5.72-1.52-1.54-3.53-2.5-5.68-2.7C89.2,6.26,38.67,1.59,13.97,3.19c-2.16.14-4.18,1.09-5.67,2.66-1.49,1.57-2.34,3.64-2.38,5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m13.02,20.14c-.95,22.36-3.97,96.81-3,124.28.07,1.93.85,3.78,2.2,5.16,1.35,1.39,3.17,2.22,5.1,2.34,16.53.98,58.91,3.11,83.15,1.12,2.11-.18,4.08-1.11,5.56-2.63,1.47-1.52,2.35-3.52,2.46-5.64,1.22-22.81,4.75-92.1,3.83-119.3-.07-2.1-.91-4.1-2.35-5.62-1.45-1.52-3.4-2.46-5.49-2.64-17.93-1.61-63.79-5.44-84.39-4.31-1.87.11-3.62.91-4.93,2.25-1.31,1.34-2.07,3.11-2.14,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m49.11,8.02c0,.4.15.79.43,1.08.28.29.66.47,1.06.49,4.12.21,15.75.83,20.95,1.12.24.01.48-.03.7-.12.22-.09.42-.24.57-.42.16-.18.27-.39.33-.63.06-.23.07-.47.02-.71v-.17c-.06-.34-.23-.64-.49-.87-.25-.23-.57-.37-.91-.4-7.03-.7-14.08-1.02-21.14-.96-.41,0-.8.18-1.09.48-.29.3-.44.69-.44,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m125.66,139.5c12.28,0,22.23-9.96,22.23-22.25s-9.95-22.25-22.23-22.25-22.23,9.96-22.23,22.25,9.95,22.25,22.23,22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m126.06,136.98c10.72,0,19.42-8.7,19.42-19.44s-8.69-19.43-19.42-19.43-19.42,8.7-19.42,19.43,8.69,19.44,19.42,19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m140.1,45.2c12.28,0,22.23-9.96,22.23-22.25S152.37.69,140.1.69s-22.23,9.96-22.23,22.25,9.95,22.25,22.23,22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m140.48,42.67c10.72,0,19.42-8.7,19.42-19.44s-8.69-19.44-19.42-19.44-19.42,8.7-19.42,19.44,8.69,19.44,19.42,19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m140.48,42.67c10.72,0,19.42-8.7,19.42-19.44s-8.69-19.44-19.42-19.44-19.42,8.7-19.42,19.44,8.69,19.44,19.42,19.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m140.51,22.03c3.76,0,6.81-3.05,6.81-6.82s-3.05-6.82-6.81-6.82-6.81,3.05-6.81,6.82,3.05,6.82,6.81,6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m133.97,13.3c-2.99,10.37-5.03,19.79-4.7,22.43l8.73-.92,1.01-19.18-5.04-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m143.64,12.23l-1.2,23.44,9.87,5.26c-.2-8.01-4.29-28.59-5.96-29.16l-2.71.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m143.64,24.93l.29,6.38-6.2.93-.38-6.71,6.29-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m146.57,21.08s-1.49,6.63-5.5,7.42c-4.01.8-5.2-5.45-5.41-5.9,0,0-.9.43-1.12-.47-.22-.9-1.25-3.13.74-3.08-.22-1.13-.12-2.3.3-3.36.68-1.12,2.07-3.72,4.94-2.99,2.87.73,7.47,3.19,6.05,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m143.83,29.18l3.92,2.07-5.14,5.61-9.49-5.98c1.35-.59,2.74-1.06,4.17-1.41l6.54-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m135.52,13.12c-1.33,1.87-.28,3.54-.65,4.89,2.28-.64,4.63-1,7-1.05.28-.9-.26-2.39-.54-3.57.44,1.12,1.41,2.83,1.31,3.71,1.77.08,1.41.11,3.36.91l-1.51-5.36c-3.45-1.67-6.43-1.46-8.98.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m142.12,6.76c0,1.3-1.22,2.76-2.11,2.76-.58-.21-1.09-.58-1.46-1.07-.37-.49-.6-1.08-.64-1.69-.03-.3,0-.59.09-.88.09-.28.24-.54.44-.76.2-.22.44-.4.71-.52.27-.12.56-.18.86-.18s.59.06.86.18c.27.12.51.3.71.52.2.22.35.48.44.76.09.28.12.58.09.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m150.56,45.39l2.16-12.02c-2.78-1.77-5.76-3.17-8.9-4.18-1.01,2.09-5.6,1.88-6.54.26-3.12.85-6.08,2.23-8.75,4.06l2.96,11.89h19.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m156.49,43.25c-1.75-7.48-3.76-9.89-3.76-9.89l-3.19,9.84s.38.79.9,2.19h4.4c.26,0,.51-.07.74-.18.23-.12.43-.28.59-.49.16-.2.27-.44.33-.69.06-.25.05-.51,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m131.7,45.39c.38-1.37.86-2.71,1.44-4.01l-4.62-7.85c-1.6,3.1-2.63,6.47-3.04,9.94-.03.24-.01.49.06.73.07.24.19.45.36.64.16.18.36.33.59.43.22.1.47.15.71.15l4.49-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m144.3,12.72c2.24,5.8,3.43,22.15,2.03,30.8,2.24-7.55,4.92-17.13.75-30l-2.78-.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m151.03,93.54c12.28,0,22.23-9.96,22.23-22.25s-9.95-22.25-22.23-22.25-22.23,9.96-22.23,22.25,9.95,22.25,22.23,22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m151.42,91.02c10.72,0,19.42-8.7,19.42-19.44s-8.69-19.44-19.42-19.44-19.42,8.7-19.42,19.44,8.69,19.44,19.42,19.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m173.14,89.42c-.78-4.06-2.08-8-3.87-11.72l-3.69,12.8.17.47h6.19c.19,0,.37-.05.54-.14.17-.08.31-.21.43-.35.12-.15.2-.32.24-.5.04-.18.04-.37,0-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m141.22,90.92c.4-1.45.72-2.38.72-2.38l-6.03-10.84s-1.37,1.64-2.84,11.02c-.05.27-.03.56.04.82.07.27.2.52.38.73.18.21.4.39.65.5.25.12.52.18.8.18l6.27-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m161.98,90.92l-1.64-17.15c-7.29-2.7-16.51.33-16.51.33l-.75,16.82c6.23,1.32,12.66,1.32,18.89,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m148.62,68.37l-.13,4.49c0,.22.06.43.18.61s.3.32.51.39c1.86.72,3.91.79,5.82.21.22-.08.41-.24.53-.44.12-.21.17-.45.13-.68l-.68-4.62-6.34.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m146.31,60.1s.78,8.1,2.53,10.17c0,0,5.24.47,7.15-.64.89-3.07,1.29-6.26,1.19-9.45.03-.69-.09-1.38-.34-2.03-.25-.65-.62-1.24-1.11-1.73-.48-.5-1.06-.89-1.7-1.16-.64-.27-1.32-.4-2.02-.4-6.35-.48-5.71,5.24-5.71,5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m156.62,62.65s.48-1.44,1.28-1.44-.17,3.81-1.28,3.81v-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m147.03,63.02s-.66-1.35-1.45-1.24c-.78.1.67,3.76,1.77,3.61l-.33-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m146.42,61.11s.62,7.85,2.75,10.51c.09.12.21.22.34.29.13.07.28.11.43.12,1.81.13,3.63.07,5.42-.18.2-.04.38-.14.53-.29.15-.14.25-.32.31-.52.19-.52.34-1.05.45-1.59.06-1.21.33-4.56.68-9.13l-.33-.52c-.1,1.05-.75,7.78-1.77,7.94-.15.02-.31.02-.46,0-.62-.13-.81-.62-1.24-.94-.42-.25-.91-.38-1.41-.35-.49.03-.97.2-1.36.5-.29.31-.64.58-1.02.77-.24.1-.49.17-.75.18-.75,0-1.49-2.98-1.9-6.99l-.67.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m155.04,58.08s-4.05,3.51-8.45,3.5c0,0-2.51-5.61,2.41-6.58,4.92-.98,5.09.27,5.09.27,0,0,5.75-1.2,3.19,5.7l-2.24-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m141.21,90.92h4.34l2.07-17.71c-5.69.52-11.71,4.49-11.71,4.49l4.48,10.88c.32.76.59,1.55.82,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m165.89,90.92c.24-.98.53-1.95.87-2.9l2.51-10.32c-5-3.9-12.8-4.81-12.8-4.81l2.91,18.08,6.5-.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m61.29,41.43c-.12.46-.11.94.01,1.39.12.46.36.87.69,1.21.33.34.74.58,1.19.72.45.13.93.15,1.39.04,2.2-.55,4.46-.82,6.72-.81,14.71.57,8.96,10.09,8.96,11.66,0,3.13,3.08-1.64,3.25-.58.38,2.24-1.4,9.26-1.4,9.26,0,0,9.42-2,12.48-6.58,3.06-4.59-.38-14.92-1.52-18.74-1.14-3.82-8.8-7.65-13-7.27-3.73.39-15.7-1.4-18.78,9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m81.63,57.79s1.12-5.73,4.2-4.59c3.08,1.14-2.3,7.67-4.2,8.79v-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m33.5,65.5l-.34,10.9c-.01.52.14,1.03.44,1.46.3.43.72.75,1.22.93,2.78.99,8.54,2.48,14.01.52.53-.19.98-.57,1.27-1.06.29-.49.4-1.06.32-1.63l-1.64-11.14h-15.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m28.91,45.61s1.9,19.5,6.11,24.47c0,0,12.62,1.12,17.2-1.53,2.17-7.38,3.15-15.06,2.9-22.76,0,0,.58-11.88-12.46-12.81-15.28-1.16-13.75,12.62-13.75,12.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m53.75,51.72s1.12-3.43,3.06-3.43-.38,9.18-3.06,9.18v-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m30.65,52.63s-1.6-3.25-3.54-3.01c-1.94.25,1.61,9.04,4.27,8.68l-.73-5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m30.23,55.9s.44,11.65,5.6,17.56c.23.27.52.49.84.64.32.15.67.24,1.02.26,2.61.12,9.29.35,13.07-.4.46-.09.89-.3,1.24-.61.35-.31.62-.7.78-1.14.92-2.73,2.53-7.01,1.97-16.82l-3.07,7.33c-2.24,6.06-3.51-1.3-4.57-1.21h-6.91c-.73.06-1.54,4.59-4.21,3.26l-5.75-8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m49.92,41.02s-9.74,10.01-20.34,9.98c0,0-6.03-16.1,5.82-18.79,11.84-2.68,12.24.77,12.24.77,0,0,13.85-3.36,7.69,16.26l-5.4-8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m70.35,64.68v14.49c0,.57.2,1.12.57,1.55.37.43.88.71,1.44.8,2.47.44,5,.35,7.44-.25.56-.17,1.05-.55,1.35-1.05.31-.5.42-1.1.31-1.68l-2.7-13.85h-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m64.72,43.41s-9.17,24.48,2.49,27.45c13.72,3.5,18.34-14.58,18.34-14.58,0,0-12.03-34.7-20.83-12.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m91.75,43.91s-1.02,4.39,2.75,3.55c3.77-.84-2.34-4.68,0,0,2.34,4.68,2.25,7.03,2.25,7.03.61.03,1.2.24,1.7.61.5.36.87.86,1.06,1.42.08.27.26.51.5.67.25.16.54.23.82.19.33-.04.67.02.98.18s.55.4.71.7c.38.6.24,4.56-4.07,9.49-2.57,2.9-4.49,11.42-13.65,8.98-1.94-.57-3.77-1.51-5.37-2.75-1.6-1.25-2.93-2.78-3.92-4.49-.99-1.72-1.62-3.59-1.84-5.5-.22-1.91-.04-3.81.55-5.6,1.27-1.29,2.22-2.84,2.79-4.55.57-1.71.76-3.54.53-5.36-.39-2.38-1.7-4.58-3.69-6.16-.72-.45-1.53-.74-2.36-.85,0,0-2.84,3.59-5.61,1.96.23-.27.36-.62.37-.98,0-.36-.12-.73-.35-1.03-.77-1.12-1.83-5.32,3.82-5.61.22-.02.43-.09.6-.22.17-.12.3-.29.37-.49.52-1.26,2.24-3.86,7.82-3.82,7.09.02,10.67,2.63,11.25,6.56.05.28.21.55.44.74.81.65,1.4,1.52,1.69,2.48.28.96.24,1.96-.12,2.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 60.08,
    cy: 110.54,
    r: 34.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m60.08,83.43h0c14.97,0,27.1,12.13,27.1,27.1h0c0,14.97-12.13,27.1-27.1,27.1h0c-14.97,0-27.1-12.13-27.1-27.1h0c0-14.97,12.13-27.1,27.1-27.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m45.34,108.06c-.04-.42-.22-.74-.53-.97-.31-.23-.74-.35-1.28-.35-.37,0-.67.05-.93.16-.25.1-.44.24-.58.42-.13.18-.2.38-.2.61,0,.19.03.36.12.5.09.14.21.26.37.37.16.1.33.19.54.26.2.07.42.13.65.19l.95.23c.46.1.89.24,1.27.41.39.17.72.38,1,.64.28.25.5.55.66.89.16.34.24.73.24,1.17,0,.65-.17,1.21-.5,1.69-.32.47-.79.84-1.41,1.1-.61.26-1.35.39-2.21.39s-1.6-.13-2.23-.39c-.63-.26-1.12-.65-1.48-1.16-.35-.52-.54-1.16-.55-1.92h2.17c.02.36.13.65.31.89.18.23.43.41.73.53.31.12.65.18,1.04.18s.71-.06.99-.17c.28-.11.5-.26.66-.46.16-.2.23-.42.23-.68,0-.24-.07-.44-.21-.6-.14-.16-.34-.3-.61-.41-.27-.11-.59-.22-.98-.31l-1.15-.29c-.89-.22-1.6-.56-2.12-1.02-.52-.46-.77-1.08-.77-1.87,0-.64.17-1.2.51-1.68.35-.48.83-.85,1.43-1.12.61-.27,1.3-.4,2.07-.4s1.47.13,2.06.4c.59.27,1.05.64,1.38,1.12.33.48.5,1.03.51,1.67h-2.15Zm5.04,7.68c-.34,0-.63-.12-.88-.36-.24-.24-.36-.54-.36-.88s.12-.63.36-.87c.24-.24.54-.36.88-.36s.62.12.87.36c.25.24.37.53.37.87,0,.23-.06.44-.18.63-.11.19-.26.34-.45.45-.19.11-.39.17-.62.17Zm12.82-5.43c0,1.15-.22,2.14-.66,2.95-.43.81-1.03,1.43-1.78,1.86-.75.42-1.59.64-2.52.64s-1.79-.21-2.53-.64c-.75-.43-1.34-1.05-1.77-1.86-.43-.81-.65-1.79-.65-2.94s.22-2.14.65-2.95c.43-.81,1.03-1.43,1.77-1.85.75-.43,1.59-.64,2.53-.64s1.78.21,2.52.64c.75.42,1.34,1.04,1.78,1.85.44.81.66,1.79.66,2.95Zm-2.27,0c0-.75-.11-1.38-.34-1.89-.22-.51-.53-.9-.94-1.17-.4-.27-.88-.4-1.42-.4s-1.01.13-1.42.4c-.4.27-.72.66-.94,1.17-.22.51-.33,1.14-.33,1.89s.11,1.38.33,1.89c.22.51.54.9.94,1.17.4.27.88.4,1.42.4s1.01-.13,1.42-.4c.4-.27.72-.66.94-1.17.22-.51.34-1.14.34-1.89Zm4.51,5.43c-.34,0-.63-.12-.88-.36-.24-.24-.36-.54-.36-.88s.12-.63.36-.87c.24-.24.54-.36.88-.36s.62.12.87.36c.25.24.37.53.37.87,0,.23-.06.44-.18.63-.11.19-.26.34-.45.45-.19.11-.39.17-.62.17Zm8.84-7.68c-.04-.42-.22-.74-.53-.97-.31-.23-.74-.35-1.28-.35-.37,0-.67.05-.93.16-.25.1-.44.24-.58.42-.13.18-.2.38-.2.61,0,.19.03.36.12.5.09.14.21.26.37.37.16.1.33.19.54.26.2.07.42.13.65.19l.95.23c.46.1.89.24,1.27.41.39.17.72.38,1,.64s.5.55.66.89c.16.34.24.73.24,1.17,0,.65-.17,1.21-.5,1.69-.32.47-.79.84-1.41,1.1-.61.26-1.35.39-2.21.39s-1.6-.13-2.23-.39c-.63-.26-1.12-.65-1.48-1.16-.35-.52-.54-1.16-.55-1.92h2.17c.02.36.13.65.31.89.18.23.43.41.73.53.31.12.65.18,1.04.18s.71-.06.99-.17c.28-.11.5-.26.66-.46.16-.2.23-.42.23-.68,0-.24-.07-.44-.21-.6-.14-.16-.34-.3-.61-.41-.27-.11-.59-.22-.98-.31l-1.15-.29c-.89-.22-1.6-.56-2.12-1.02-.52-.46-.77-1.08-.77-1.87,0-.64.17-1.2.51-1.68.35-.48.83-.85,1.43-1.12s1.3-.4,2.07-.4,1.47.13,2.06.4c.59.27,1.05.64,1.38,1.12.33.48.5,1.03.51,1.67h-2.15Zm5.04,7.68c-.34,0-.63-.12-.88-.36-.24-.24-.36-.54-.36-.88s.12-.63.36-.87c.24-.24.54-.36.88-.36s.62.12.87.36c.25.24.37.53.37.87,0,.23-.06.44-.18.63-.11.19-.26.34-.45.45-.19.11-.39.17-.62.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m132.35,110.17c0,4.91-2.89,6.17-6.47,6.17s-6.47-1.27-6.47-6.17,2.9-7.26,6.47-7.26,6.47,2.35,6.47,7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m129.35,117.43h-6.94v5.73h6.94v-5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m137.55,140.73v-14.49c0-1.44-.57-2.83-1.59-3.85-1.02-1.02-2.41-1.6-3.85-1.6h-12.48c-1.44,0-2.83.57-3.85,1.6-1.02,1.02-1.59,2.41-1.59,3.85v14.49h23.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m127.75,123.46l-1.87-2.57-1.87,2.57,1.54,2.12-1.54,11.83,1.87,2.87,1.87-2.87-1.54-11.83,1.54-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m137.55,140.73v-14.49c0-1.44-.57-2.83-1.59-3.85-1.02-1.02-2.41-1.6-3.85-1.6h-1.53l-4.7,14.07v5.85h11.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m131.89,128l-1.02-1.75,2.24-.79-.68-4.64h-1.84l-4.7,14.07v5.85h.65l5.35-12.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m114.2,140.73v-14.49c0-1.44.57-2.83,1.59-3.85,1.02-1.02,2.41-1.6,3.85-1.6h1.55l4.7,14.07v5.85h-11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m119.87,128l1.02-1.75-2.23-.79.68-4.64h1.82l4.7,14.07v5.85h-.65l-5.33-12.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m131.55,112.42c0,4.34-2.54,7.85-5.67,7.85s-5.68-3.51-5.68-7.85,2.54-7.85,5.67-7.85,5.68,3.51,5.68,7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m122.38,119.64l-1.12,1.18,2.87,3.29,1.75-3.26-3.5-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m129.38,119.64l1.12,1.18-2.87,3.29-1.75-3.26,3.5-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m122.05,106.08c2.31,4.8,9.38,2.17,9.38,2.17l-1.4-2.67-3.08-2.04-4.17,1.22s-1,.55-.73,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m134.39,126.94c0,.42-.12.84-.36,1.19-.23.35-.57.63-.96.79s-.82.21-1.24.12c-.42-.08-.8-.28-1.1-.58-.3-.3-.5-.68-.59-1.09-.08-.41-.04-.84.12-1.24.16-.39.44-.73.79-.96.35-.23.77-.36,1.19-.36.57,0,1.11.22,1.51.62.4.4.63.94.63,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m133.72,126.47h-.98v-.98h-.96v.98h-.98v.95h.98v.98h.96v-.98h.98v-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m129.76,130.44h5.07c.14,0,.28.06.38.16.1.1.16.24.16.38v2.63c0,.14-.06.28-.16.38-.1.1-.24.16-.38.16h-5.07c-.14,0-.28-.06-.38-.16s-.16-.24-.16-.38v-2.62c0-.07.01-.14.04-.21.03-.07.07-.13.12-.18.05-.05.11-.09.18-.12.07-.03.14-.04.21-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m134.83,130.8h-5.07c-.1,0-.18.08-.18.18v2.63c0,.1.08.18.18.18h5.07c.1,0,.18-.08.18-.18v-2.63c0-.1-.08-.18-.18-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m132.59,129.81h-.59v1.45h.59v-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m134.6,131.77h-4.62v.33h4.62v-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m134.6,132.68h-4.62v.33h4.62v-.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFamiliaamigos);
export default __webpack_public_path__ + "static/media/ico-familiaamigos.1acc4932911bb11114836afffd244d01.svg";
export { ForwardRef as ReactComponent };